import { CommonModule } from '@angular/common'
import { Component, computed, DestroyRef, inject, input, output } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { CanvasArgs, CanvasCommand } from '../commands/canvas-command.model'

@Component({
  selector: 'ddc-command-dialog-invoker',
  templateUrl: './ddc-command-dialog-invoker.component.html',
  styleUrls: ['./ddc-command-dialog-invoker.component.scss'],
  imports: [CommonModule, AngularMaterialsModules],
  standalone: true,
})
export class DdcCommandDialogInvokerComponent {
  private readonly destroyRef = inject(DestroyRef)

  command = input.required<CanvasCommand>()
  args = input.required<CanvasArgs>()
  executed = output<CanvasCommand>()

  isEnabled = computed(() => this.command()?.canExecute(this.args()) ?? false)

  tooltipText = computed(() => this.command()?.getTooltip(this.args()) ?? '')

  iconColor = computed(() => {
    if (!this.isEnabled()) return undefined
    return this.command()?.color
  })

  onExecute(): void {
    if (!this.isEnabled()) return

    const cmd = this.command()

    cmd
      .execute(this.args())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.executed.emit(cmd))
  }
}
